import Dialog, { DialogContent } from 'material-ui/Dialog'
import withStyles from 'material-ui/styles/withStyles'
import React from 'react'
import images from '../common/images'
import styleSheet from './AllWebChatStyle.style'

class WebChatRegisterRecommendModal extends React.Component {
  render() {
    const { userLoggedIn } = this.props
    const classes = this.props.classes
    return (
      <Dialog fullWidth={true} open={!userLoggedIn}>
        <DialogContent>
          <a href="/">
            <div
              className={`classes.circle ${classes.recModal_closeBtn}`}
              onClick={() => this.props.onChange('planChangeModal', false)}
            >
              <div>×</div>
            </div>
          </a>

          <div>
            <img className={classes.recModal_img} src={images.icNurse} width={100} height={100} />
          </div>
          <div className={classes.recModal_content}>
            <p style={{ fontSize: 18 }}>ご利用には会員登録・ログインが必要です。</p>
            <p style={{ fontSize: 13 }}>会員登録の際は法人コード（クーポンコード）をお手元にご用意ください。</p>

            <a href="/users/sign_up">
              <button className={`btn btn-primary ${classes.modal_priBtn}`}>会員登録をする</button>
            </a>
            <a href="/users/sign_in">
              <button className={`btn btn-default ${classes.modal_defBtn}`}>ログインする</button>
            </a>
          </div>
        </DialogContent>
      </Dialog>
    )
  }
}

export default withStyles(styleSheet)(WebChatRegisterRecommendModal)
